// extracted by mini-css-extract-plugin
export var pCaseStudies = "caseStudies-module--p-case-studies--1xpLI";
export var swiperWrapper = "caseStudies-module--swiper-wrapper--Ftvhl";
export var swiperSlide = "caseStudies-module--swiper-slide--2YPNs";
export var pCaseStudies__navigation = "caseStudies-module--p-case-studies__navigation--1m_Jc";
export var next = "caseStudies-module--next--162nk";
export var prev = "caseStudies-module--prev--36Pah";
export var visible = "caseStudies-module--visible--1cbN0";
export var subcopyBefore = "caseStudies-module--subcopy-before--5xPMQ";
export var subcopyAfter = "caseStudies-module--subcopy-after--1tAKQ";
export var standby = "caseStudies-module--standby--1vMG4";
export var lContent__inner = "caseStudies-module--l-content__inner--10AXc";
export var oCase = "caseStudies-module--o-case--ojoMq";